import React from 'react';

import SelectedStudents from './SelectedStudents';
import AllStudents from './AllStudents';

const Index: React.FC = () => {
  return (
    <>
      <SelectedStudents />
      <AllStudents />
    </>
  );
};

export default Index;
